const _excluded = ["title", "onRefresh", "skin", "message", "error"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useEffect } from 'react';
import { Page } from "../Page";
import { PageEmptyState } from "../PageEmptyState";
import { Button } from "../Button";
import { PageErrorStateIcon } from "./PageErrorStateIcon";
/** Renders page contents that indicate an error occurred, with an optional refresh button. */
export function PageErrorState(props) {
  const {
      title,
      onRefresh,
      skin,
      message,
      error
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  useEffect(() => {
    if (error) {
      console.error('PageErrorState error', error);
    }
  }, [error]);
  return /*#__PURE__*/React.createElement(Page, _extends({
    header: title,
    skin: skin
  }, rest), /*#__PURE__*/React.createElement(PageEmptyState, {
    illustration: /*#__PURE__*/React.createElement(PageErrorStateIcon, null),
    message: message || 'Something went wrong. Refresh the page',
    actions: /*#__PURE__*/React.createElement(Button, {
      onClick: onRefresh,
      "data-testid": "page-error-refresh-btn"
    }, "Refresh")
  }));
}